<template>
  <b-form-group :label="label">
    <template #label>
      <span>{{ $t(label) }}</span>
      <span v-if="required && label" class="text-danger">*</span>
    </template>
    <b-input-group>
      <money
        v-model="content"
        class="form-control"
        v-bind:class="{ 'is-valid': state, 'is-invalid': state == false }"
        @input="handleInput"
        v-bind="maskMoney"
        @blur.native="blur()"
      />
      <slot name="append"></slot>
      <b-form-invalid-feedback>{{ feedback }}</b-form-invalid-feedback>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  name: 'InputNumberValue',
  props: {
    value: { type: [Number], default: 0 },
    label: { type: String, required: false },
    upper: { type: Boolean },
    required: { type: Boolean },
    requiredMessage: { type: String },
    length: { type: Number, default: 0 },
    lengthMessage: { type: String },
    validate: { type: Boolean, default: null },
    locale: {
      type: String,
      default: 'pt-BR',
    },
    precision: { type: Number, default: 2 },
  },
  data() {
    return {
      content: this.value,
      validarFormulario: false,
      hasError: false,
      errorMessage: '',
      money_pt_BR: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: this.precision,
        masked: false,
      },
      money_en_US: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision: this.precision,
        masked: false,
      },
    };
  },
  computed: {
    maskMoney() {
      if (this.locale == 'en-US') return this.money_en_US;

      return this.money_pt_BR;
    },
    requiredValid() {
      return !(this.required && this.content == '');
    },
    lengthValid() {
      return !(this.length > 0 && this.content?.length != this.length);
    },
    state() {
      if (!this.validarFormulario) return null;

      if (!this.requiredValid) return false;
      if (!this.lengthValid) return false;
      if (this.hasError) return false;
      if (this.validate != null) return this.validate;

      return true;
    },
    feedback() {
      if (!this.requiredValid)
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.REQUERIDO').formatUnicorn({
            name: this.label,
          })
        );
      if (!this.minValid)
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.VALOR_MINIMO').formatUnicorn({
            min: this.min,
          })
        );
      if (!this.maxValid)
        return (
          this.requiredMessage ||
          this.$t('CAMPOS_VALIDACAO.VALOR_MAXIMO').formatUnicorn({
            max: this.max,
          })
        );
      if (!this.lengthValid)
        return (
          this.lengthMessage ||
          this.$t('CAMPOS_VALIDACAO.TAMANHO').formatUnicorn({
            name: this.label,
            length: this.length,
          })
        );
      if (!this.minLengthValid)
        return (
          this.minLengthMessage ||
          this.$t('CAMPOS_VALIDACAO.COMPRIMENTO_MINIMO').formatUnicorn({
            name: this.label,
            length: this.minLength,
          })
        );
      if (!this.maxLengthValid)
        return (
          this.maxLengthMessage ||
          this.$t('CAMPOS_VALIDACAO.COMPRIMENTO_MAXIMO').formatUnicorn({
            name: this.label,
            length: this.maxLength,
          })
        );
      if (this.hasError) return this.errorMessage;
      return '';
    },
  },
  methods: {
    blur() {
      this.$emit('blur');
    },
    showError(message) {
      this.validarFormulario = true;
      this.hasError = true;
      this.errorMessage = message;
    },
    handleInput() {
      if (this.upper && this.content) this.content = this.content.toUpperCase();
      this.$emit('input', this.content);
      this.hasError = false;
    },
    valid() {
      this.validarFormulario = true;
      return this.state;
    },
    clear() {
      this.content = '';
      this.validarFormulario = false;
      this.$emit('input', this.content);
    },
  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
